import { StyledContent, StyledTitle, StyledAnchors, StyledButton, StyledSection } from '@/components/styles';
import { AnchoredContent, ContentSection, PreviewLinks, Questions, Hero, Directions, Appointment, Author, SeoServiceLinks } from '@/components';
import { useRouter } from 'next/router';
import generateBlocks from '@/lib/generateBlocks';
import getCurrentBySlug from '@/lib/getCurrentBySlug';
import addSoftHyphenation from '@/lib/addSoftHyphenation';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import vars from '@/assets/styles/vars';

export default function ServicePage(props) {
  const { id, title, blocks = [], direction = {}, directions = [], questions = [], recommendations = [], banner = {}, short_content = '', author, banner_alt, h1, specialists = [] } = props;

  const { t } = useTranslation('global');
  const router = useRouter();
  const [thumbnailSwiper, getThumbnailSwiper] = useState(null);
  const [gallerySwiper, getGallerySwiper] = useState(null);

  const currentSlug = direction?.slug;
  const cur = getCurrentBySlug(directions, currentSlug);

  const AppointmentView = (props) => {
    return (
      <StyledButton style={{ width: '100%' }} size="mid" light arrow {...props}>
        {t('bookAppointment')}
      </StyledButton>
    );
  };

  const DoctorsLink = ({ slug }) => {
    const href = `/specialists?direction=${slug || ''}`;
    return <StyledAnchors.Link href={href}>{t('services.specialistsTitle')}</StyledAnchors.Link>;
  };

  const ServicesLink = ({ slug }) => {
    const href = `/services`;
    return (
      <StyledButton as={'a'} href={href} style={{ width: '100%' }} size="mid" light arrow>
        {t('main.servises.button')}
      </StyledButton>
    );
  };

  const image = {
    desktop: banner?.main_page_desktop,
    tablet: banner?.main_page_tablet,
    mobile: banner?.main_page_mobile,
  };

  const serviceBanner = {
    id,
    title: h1 || title,
    image,
    banner_alt,
    theme: 'dark',
  };

  let breadcrumbs = [
    {
      id: 1,
      title: t('main.titlePage'),
      slug: '',
      type: 'index',
    },
    {
      id: 2,
      title: 'OUR SERVICES',
      slug: '',
      type: 'services',
    },
    {
      id: 3,
      title: cur?.title,
      slug: cur?.slug || '',
      type: 'direction',
      link: `/${cur?.slug}`,
    },
    {
      id: 5,
      title: title,
      slug: '',
      type: 'service',
    },
  ];
  let breadcrumbs2 = [
    {
      id: 1,
      title: t('main.titlePage'),
      slug: '',
      type: 'index',
    },
    {
      id: 2,
      title: 'OUR SERVICES',
      slug: '',
      type: 'services',
    },
    {
      id: 3,
      title: cur?.title,
      slug: cur?.slug || '',
      type: 'direction',
      link: `/${cur?.slug}`,
    },
    {
      id: 4,
      title: direction?.title,
      slug: direction?.slug || '',
      type: 'direction',
      link: `/${direction?.slug}`,
    },
    {
      id: 5,
      title: title,
      slug: '',
      type: 'service',
    },
  ];

  const thumbnailParams = {
    getSwiper: getThumbnailSwiper,
    direction: 'horizontal',
    slidesPerView: 'auto',
    spaceBetween: 40,
    watchOverflow: true,
    watchSlidesVisibility: true,
    breakpoints: {
      [vars.breakpoints.tablet + 1]: {
        direction: 'vertical',
        spaceBetween: 20,
      },
    },
  };

  const params = {
    slidesPerView: 1,
    getSwiper: getGallerySwiper,
    preloadImages: true,
    resistanceRatio: 0,
    watchOverflow: true,
    keyboard: true,
    speed: 600,
    autoHeight: true,
    spaceBetween: 45,
    noSwipingClass: 'no-content-swiping',
    updateOnWindowResize: true,
    allowTouchMove: false,
    breakpoints: {
      [vars.breakpoints.tablet + 1]: {
        spaceBetween: 25,
      },
    },
  };

  const swiperData = { gallerySwiper, thumbnailSwiper, params, thumbnailParams };

  const handleClick = (slug) => {
    if (!slug || !directions?.length) return;
    const active = directions.reduce((acc, cur) => {
      return cur.slug === slug ? cur : cur.children?.find((i) => i.slug === slug) ? cur.children?.find((i) => i.slug === slug) : acc;
    }, null);

    if (active && (active.children?.length || active.service_count > 0)) {
      const targetSlug = active.children?.length ? active.children[0].slug : slug;
      router.push({ pathname: `/${targetSlug}`, query: {} }, { pathname: `/${targetSlug}`, query: {} }, { shallow: false });

    } else {
      router.push({ pathname: `/${slug}`, query: {} }, { pathname: `/${slug}`, query: {} }, { shallow: true });
    }
  };

  useEffect(() => {
    if (gallerySwiper) {
      setTimeout(() => {
        gallerySwiper.updateAutoHeight();
      }, 500);
      setTimeout(() => {
        gallerySwiper.updateAutoHeight();
      }, 1000);
    }
  }, [gallerySwiper]);

  return (
    <>
      <Hero data={[serviceBanner]} size="large" breadcrumbs={cur?.slug == direction?.slug ? [...breadcrumbs] : [...breadcrumbs2]} h1/>
      <StyledContent>
        <div style={{ overflow: 'hidden' }}>
          <StyledContent.Container>{!!directions?.length && <Directions directions={directions} active={cur} onClick={handleClick} center asLinks />}</StyledContent.Container>
        </div>
        <StyledContent.Container>
          <StyledContent.Columns>
            <AnchoredContent
              key={router.asPath}
              slider
              singleLink={false}
              swiperData={swiperData}
              navFooter={
                <>
                  <DoctorsLink slug={cur?.slug} />
                  <div className="button-wrap" style={{ marginTop: '20px' }}>
                    <Appointment render={AppointmentView} />
                  </div>
                </>
              }
            >
              {blocks && blocks.length > 0 && (
                <div type="block" title={blocks[0]?.data?.title || blocks[1]?.data?.title || title} slug={blocks[0]?.data?.slug || blocks[1]?.data?.slug || ''}>
                  {/* <StyledTitle size="large" mb="small" as="h1" black>
                    {addSoftHyphenation(title, 15)}
                  </StyledTitle> */}
                  {generateBlocks([blocks[0]])}
                  {blocks.length > 1 && !blocks[0]?.data?.title && generateBlocks([blocks[1]])}
                </div>
              )}
              {blocks && blocks.length > 1 && blocks[0]?.data?.title && generateBlocks([blocks[1]])}
              {blocks && blocks.length > 2 && generateBlocks([...blocks].slice(2))}

              {questions && questions.length > 0 && (
                <ContentSection pt="none" type="questions">
                  <Questions data={questions} swiperData={swiperData} />
                </ContentSection>
              )}
            </AnchoredContent>
            <StyledContent.MobileLink>
              <DoctorsLink slug={cur?.slug} />
            </StyledContent.MobileLink>
          </StyledContent.Columns>
          {/*author && (
            <StyledSection pt="none" pb="large">
              <StyledContent.Description>
                <StyledContent.Html >
                  <div style={{marginBottom:'15px'}}>Authored by:</div>
                </StyledContent.Html>
                <Author {... author}/>
              </StyledContent.Description>
            </StyledSection>
          )*/}
          {short_content && (
            <StyledSection pt="none" pb="large">
              <StyledContent.Description>
                <StyledContent.Html dangerouslySetInnerHTML={{ __html: short_content }} dark />
              </StyledContent.Description>
            </StyledSection>
          )}
          <div></div>
        </StyledContent.Container>
        <div style={{ overflow: 'hidden' }}>
          <StyledContent.Container>
            {recommendations && recommendations.length > 0 && (
              <ContentSection pt="none" type="recommendations">
                <PreviewLinks data={recommendations} items slider key={router.asPath}/>
              </ContentSection>
            )}
          </StyledContent.Container>
        </div>
        <StyledContent.Container>
          <StyledContent.MobileLink>
            <div style={{ marginTop: '20px' }}>
              <Appointment render={AppointmentView} />
            </div>
            <div style={{ marginTop: '20px' }}>
              <ServicesLink slug={cur?.slug} />
            </div>
          </StyledContent.MobileLink>
        </StyledContent.Container>
      </StyledContent>
      <SeoServiceLinks specialists={specialists} />
    </>
  );
}
